import { useState, useCallback } from 'react';
import styled from '@emotion/styled';
import Select from 'react-select';
import type { CSSObjectWithLabel } from 'react-select';

export type TagDetailsDashboardPublishTypeProps = {
  label?: string;
  value: string | null | undefined;
  /** If provided, renders a react-select dropdown. Otherwise shows a read-only value. */
  onChange?: (value: string | null) => void;
};

type OptionType = { value: string | null; label: string };

const OPTIONS: OptionType[] = [
  { value: 'Journey Stage', label: 'Journey Stage' },
  { value: 'Journey Dimension', label: 'Journey Dimension' },
  { value: null, label: 'None' },
];

export const TagDetailsDashboardPublishType = ({
  label = 'Dashboard Display Type',
  value,
  onChange,
}: TagDetailsDashboardPublishTypeProps) => {
  const [state, setState] = useState(value ?? null);

  const handleChange = useCallback(
    (next: string | null) => {
      setState(next);
      onChange?.(next);
    },
    [onChange],
  );

  return (
    <Root>
      <Label>{label}</Label>
      <Value>
        {onChange ? (
          <Select<OptionType>
            value={OPTIONS.find(o => o.value === state) ?? null}
            options={OPTIONS}
            getOptionLabel={o => o.label}
            getOptionValue={o => String(o.value)}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
            styles={{ menuPortal: base => ({ ...base, zIndex: 8 }) as CSSObjectWithLabel }}
            onChange={v => handleChange(v ? v.value : null)}
          />
        ) : (
          <Text>{state ?? 'N/A'}</Text>
        )}
      </Value>
    </Root>
  );
};

TagDetailsDashboardPublishType.displayName = 'TagDetails.DashboardPublishType';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.div`
  font-family: var(--font-bold);
  color: var(--gray-d);
  font-size: 14px;
`;

const Value = styled.div`
  min-height: 20px;
  display: flex;
  align-items: center;
  width: 100%;
`;

const Text = styled.span`
  font-size: 14px;
  color: var(--black);
`;
